.pageContent {
  padding: 4rem;
  height: 100%;
}

.form {
  width: 240px;
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiL2hvbWUvcnVubmVyL3dvcmsvcG9zL3Bvcy9zcmMvZmVhdHVyZS9wb3MiLCJzb3VyY2VzIjpbIlRpbWVDbG9ja0xvZ2luLm1vZHVsZXMuc2NzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQTtFQUNFO0VBQ0E7OztBQUdGO0VBQ0UiLCJzb3VyY2VzQ29udGVudCI6WyJAaW1wb3J0ICcvaG9tZS9ydW5uZXIvd29yay9wb3MvcG9zL3NyYy9zdHlsZXMvc2Fzcy9fZ2xvYmFscy5zY3NzJztcbi5wYWdlQ29udGVudHtcbiAgcGFkZGluZzogNHJlbTtcbiAgaGVpZ2h0OiAxMDAlO1xufVxuXG4uZm9ybSB7XG4gIHdpZHRoOiAyNDBweDtcbn1cbiJdfQ== */